export default {
      id: "Icon--hidden-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--hidden",
      toString: function () {
        return this.url;
      }
    }